/**
 * SerbestKwDugmesi.jsx — the header button of the organizer's Talepler page that opens "Stands Above the Free kW" with the number of stands over (backlog #500,
 * 2026-10-19; backend #499).
 *
 * The number is the fair's whole count (no search, no hall): one small read of the page's own endpoint (size 1). If that read fails the button is still drawn, without
 * a number: the page behind it says what is wrong. Draws nothing without a fair.
 */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Badge } from "reactstrap";
import { Zap } from "lucide-react";
import { useTranslation } from "react-i18next";
import { getOrganizatorSerbestKwAsimi } from "../../services/portalService";

export const SERBEST_KW_ASIMI_YOLU = "/Firma/Organizator/SerbestKwAsimi";

export default function SerbestKwDugmesi({ fuarId }) {
  const { t } = useTranslation("portal");
  // the count remembers its fair, so a number read for another fair is never shown (no state reset inside the effect)
  const [sonuc, setSonuc] = useState({ fuarId: null, sayi: null });

  // KURAL: fetch Effect içindeki async fonksiyonda (react-hooks/set-state-in-effect).
  useEffect(() => {
    let ignore = false;
    async function run() {
      try {
        const out = await getOrganizatorSerbestKwAsimi(fuarId, { page: 0, size: 1 });
        if (!ignore) setSonuc({ fuarId, sayi: Number.isFinite(out?.ozet?.asanStandSayisi) ? out.ozet.asanStandSayisi : null });
      } catch {
        if (!ignore) setSonuc({ fuarId, sayi: null });
      }
    }
    if (fuarId) run();
    return () => { ignore = true; };
  }, [fuarId]);

  if (!fuarId) return null;
  const sayi = sonuc.fuarId === fuarId ? sonuc.sayi : null;
  return (
    <Link to={SERBEST_KW_ASIMI_YOLU} className="btn btn-sm btn-outline-primary d-inline-flex align-items-center gap-1 text-nowrap" data-testid="serbest-kw-dugme">
      <Zap size={14} />
      {t("organizator.serbestKwAsimi")}
      {sayi !== null && <Badge color={sayi > 0 ? "danger" : "secondary"} pill data-testid="serbest-kw-sayi">{sayi}</Badge>}
    </Link>
  );
}
